import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-permissions"
export default class extends Controller {
  static targets = ["roleSelect", "permission", "permissionRow", "permissionIcon", "permissionLabel"]

  connect() {
    // Initialize state based on current selection
    if (this.hasRoleSelectTarget) {
      this.updatePermissions()
    }
  }

  // Called when the role dropdown changes
  updatePermissions() {
    const selectedOption = this.roleSelectTarget.selectedOptions[0]
    if (!selectedOption) return

    const data = selectedOption.dataset

    // Update all permission rows to reflect the selected role
    this.permissionRowTargets.forEach(row => {
      const permissionKey = row.dataset.permission
      const isEnabled = data[permissionKey] === "true" || data[permissionKey] === true

      // Find the icon and label within this row
      const icon = row.querySelector('[data-user-permissions-target="permissionIcon"]')
      const label = row.querySelector('[data-user-permissions-target="permissionLabel"]')
      const hiddenField = row.querySelector('[data-user-permissions-target="permission"]')

      if (icon) {
        if (isEnabled) {
          icon.classList.remove('fa-circle-xmark', 'text-muted')
          icon.classList.add('fa-circle-check', 'text-success')
        } else {
          icon.classList.remove('fa-circle-check', 'text-success')
          icon.classList.add('fa-circle-xmark', 'text-muted')
        }
      }

      if (label) {
        if (isEnabled) {
          label.classList.remove('text-muted')
          label.classList.add('text-dark')
        } else {
          label.classList.remove('text-dark')
          label.classList.add('text-muted')
        }
      }

      if (hiddenField) {
        hiddenField.value = isEnabled ? '1' : '0'
      }
    })
  }

  // Called when any permission checkbox changes
  // Note: Checkboxes are currently disabled in the view, so this might not trigger
  // unless they are enabled for custom role creation.
  async updateRole() {
    const roles = this.permissionTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.id) // Using ID as the role name/key

    // Construct URL parameters
    const params = new URLSearchParams()
    roles.forEach(role => params.append("roles[]", role))

    try {
      const response = await fetch(`/profile/users/checkRole?${params.toString()}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const data = await response.json()
        const roleName = data.name
        
        // Select the option with the matching ID (which corresponds to the role name)
        // The original code used: document.querySelector('#permissions [id="'+val+'"]')
        // We can use the target to scope the search
        const option = this.roleSelectTarget.querySelector(`[id="${roleName}"]`)
        if (option) {
          option.selected = true
        }
      }
    } catch (error) {
      console.error("Error checking role:", error)
    }
  }
}
